import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, ArrowDown } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Section } from '../components/ui/Section';
export function SalesPage() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen w-full overflow-x-hidden" data-id="element-7">
      {/* Hero Section */}
      <header className="relative bg-[#F5F0E8] pt-12 pb-20 px-4 md:pt-20 md:pb-32 overflow-hidden" data-id="element-8">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-9">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="text-center md:text-left z-10" data-id="element-10">
            <span className="inline-block py-1 px-3 rounded-full bg-[#E8DCC8] text-[#4A3728] text-sm font-semibold tracking-wide mb-6" data-id="element-11">
              PARA MUJERES 40+ (PERI/MENO)
            </span>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-[#4A3728] leading-[1.1] mb-4" data-id="element-12">
              Adiós <br data-id="element-13" />
              <span className="text-[#B85C38] italic" data-id="element-14">'Hormone Belly'</span>
            </h1>
            <h2 className="text-xl md:text-2xl text-[#6B5642] mb-8 font-serif italic" data-id="element-15">
              Plan Anti-Hinchazón de 14 Días
            </h2>
            <p className="text-lg md:text-xl text-[#4A3728] mb-10 max-w-md mx-auto md:mx-0 leading-relaxed" data-id="element-16">
              Menos inflamada. Más cómoda. <br data-id="element-17" />
              <span className="font-semibold border-b-2 border-[#C9A962]" data-id="element-18">
                Sin vivir a dieta.
              </span>
            </p>
            <Button onClick={scrollToPricing} icon data-id="element-19">
              Quiero desinflamarme
            </Button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative z-0" data-id="element-20">
            <div className="absolute inset-0 bg-[#C9A962] opacity-10 rounded-full blur-3xl transform scale-90 translate-y-4" data-id="element-21"></div>
            <img src="https://cdn.magicpatterns.com/uploads/9sJJ4uLwWPmvjhpJnW8MZG/14_dias_anti_hinchazon.png" alt="Adiós Hormone Belly Plan en tablet y móvil" className="relative w-full h-auto drop-shadow-2xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-22" />
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1,
        duration: 1
      }} className="absolute bottom-6 left-1/2 transform -translate-x-1/2 text-[#B85C38] animate-bounce" data-id="element-23">
          <ArrowDown className="h-6 w-6" data-id="element-24" />
        </motion.div>
      </header>

      {/* Opening Lead */}
      <Section background="white" className="text-lg md:text-xl leading-relaxed" data-id="element-25">
        <div className="prose prose-lg prose-stone mx-auto text-[#4A3728]" data-id="element-26">
          <p className="font-serif text-2xl md:text-3xl italic text-[#B85C38] mb-8" data-id="element-27">
            Si tu barriga "aparece" en horas… lee esto.
          </p>

          <p className="mb-6" data-id="element-28">
            Si estás en tus 40s/50s y sientes que tu cuerpo cambió sin avisar,
            no estás loca.
          </p>

          <p className="mb-6" data-id="element-29">Es esa escena repetida:</p>

          <ul className="space-y-3 mb-8 pl-4 border-l-2 border-[#E8DCC8]" data-id="element-30">
            <li data-id="element-31">en la mañana te ves "normal"</li>
            <li data-id="element-32">
              en la tarde estás <strong data-id="element-33">inflada</strong>
            </li>
            <li data-id="element-34">
              en la noche te sientes <strong data-id="element-35">pesada</strong>
            </li>
            <li data-id="element-36">
              y al día siguiente vuelves a empezar con la misma duda:{' '}
              <em data-id="element-37">"¿Qué hice mal?"</em>
            </li>
          </ul>

          <p className="mb-6" data-id="element-38">
            La mayoría intenta arreglarlo como si fuera solo grasa:
            <br data-id="element-39" />
            más cardio, menos comida, más culpa.
          </p>

          <p className="font-medium text-[#B85C38]" data-id="element-40">
            Pero si tu cintura cambia en el mismo día… muchas veces no es "solo
            grasa". Es ruido. Y el ruido tiene gatillos.
          </p>
        </div>
      </Section>

      {/* Problem Section */}
      <Section background="cream" data-id="element-41">
        <div className="text-center mb-12" data-id="element-42">
          <span className="text-[#B85C38] font-bold tracking-widest text-sm uppercase mb-2 block" data-id="element-43">
            La verdad incómoda
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#4A3728] mb-6" data-id="element-44">
            No necesitas más disciplina. <br data-id="element-45" />
            <span className="italic font-serif text-[#B85C38]" data-id="element-46">
              Necesitas un mapa.
            </span>
          </h2>
        </div>

        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-[#E8DCC8]" data-id="element-47">
          <p className="text-lg md:text-xl text-[#4A3728] mb-6 leading-relaxed" data-id="element-48">
            Porque cuando no tienes un mapa, haces lo único que puedes:
            adivinar, eliminar todo, rebotar, y sentirte peor.
          </p>
          <p className="text-xl font-serif italic text-center text-[#B85C38]" data-id="element-49">
            Este plan existe para una mujer específica: <br data-id="element-50" />
            la que ya está cansada de adivinar.
          </p>
        </div>
      </Section>

      {/* Solution Section */}
      <Section background="white" data-id="element-51">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-52">
          <div data-id="element-53">
            <h2 className="text-3xl md:text-4xl font-bold text-[#4A3728] mb-6" data-id="element-54">
              Presento: <br data-id="element-55" />
              <span className="text-[#B85C38]" data-id="element-56">El Mapa de Gatillos 5D</span>
            </h2>
            <p className="text-lg text-[#6B5642] mb-8" data-id="element-57">
              Un experimento simple de 14 días para bajar hinchazón y recuperar
              control.
            </p>

            <div className="space-y-6" data-id="element-58">
              {[{
              title: 'Pausa 5D',
              desc: 'Los 5 sospechosos más comunes'
            }, {
              title: 'Menú Base',
              desc: 'Comidas repetibles, sin gourmet, sin cansancio mental'
            }, {
              title: 'Tracker de 3 minutos',
              desc: 'Gatillo → síntoma'
            }, {
              title: 'Reintroducción inteligente',
              desc: 'Para descubrir tu 1–2 gatillos reales'
            }].map((item, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: idx * 0.1
            }} className="flex items-start" data-id="element-59">
                  <div className="flex-shrink-0 mt-1" data-id="element-60">
                    <div className="w-8 h-8 rounded-full bg-[#F5F0E8] flex items-center justify-center text-[#B85C38]" data-id="element-61">
                      <Check className="w-5 h-5" data-id="element-62" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-63">
                    <h3 className="font-bold text-[#4A3728] text-lg" data-id="element-64">
                      {item.title}
                    </h3>
                    <p className="text-[#6B5642]" data-id="element-65">{item.desc}</p>
                  </div>
                </motion.div>)}
            </div>
          </div>

          <div className="bg-[#F5F0E8] p-8 rounded-3xl relative overflow-hidden" data-id="element-66">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#C9A962] opacity-10 rounded-full transform translate-x-10 -translate-y-10" data-id="element-67"></div>
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-[#B85C38] opacity-10 rounded-full transform -translate-x-5 translate-y-5" data-id="element-68"></div>

            <h3 className="text-2xl font-serif italic text-center text-[#4A3728] mb-6" data-id="element-69">
              "No es una dieta eterna."
            </h3>
            <p className="text-center text-[#6B5642] leading-relaxed" data-id="element-70">
              Es un proceso corto para que el cuerpo se calme y tú veas patrones
              claros.
            </p>
          </div>
        </div>
      </Section>

      {/* Objection Handler */}
      <Section background="cream" data-id="element-71">
        <div className="max-w-2xl mx-auto text-center" data-id="element-72">
          <h3 className="text-2xl font-bold text-[#4A3728] mb-6" data-id="element-73">
            "¿Y si yo soy de las que se inflan por todo?"
          </h3>
          <div className="bg-white p-8 rounded-xl shadow-sm" data-id="element-74">
            <p className="text-lg text-[#4A3728] mb-4" data-id="element-75">
              Perfecto. Justo por eso el plan es simple.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left mt-6" data-id="element-76">
              <div className="p-4 bg-red-50 rounded-lg border border-red-100" data-id="element-77">
                <p className="text-red-800 text-sm font-semibold mb-1" data-id="element-78">
                  Si haces cosas complicadas:
                </p>
                <p className="text-red-600" data-id="element-79">no sabes qué funcionó.</p>
              </div>
              <div className="p-4 bg-green-50 rounded-lg border border-green-100" data-id="element-80">
                <p className="text-green-800 text-sm font-semibold mb-1" data-id="element-81">
                  Si haces esto:
                </p>
                <p className="text-green-600 font-bold" data-id="element-82">sí lo sabes.</p>
              </div>
            </div>
          </div>
        </div>
      </Section>

      {/* Includes Section */}
      <Section background="white" data-id="element-83">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#4A3728] mb-12" data-id="element-84">
          Qué incluye{' '}
          <span className="font-serif italic font-normal text-[#B85C38]" data-id="element-85">
            (lo que vas a abrir hoy)
          </span>
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-86">
          {["PDF completo 'Adiós Hormone Belly' (14 días)", 'Menú Base 7 días (lo repites 2 veces)', 'Lista de compras', 'Tracker imprimible (3 minutos al día)', 'Guía de reintroducción (Días 15–21 opcional)', "Sección: 'Si no baja' (7 causas comunes + qué ajustar)"].map((item, idx) => <motion.div key={idx} whileHover={{
          y: -5
        }} className="bg-[#F9F6F2] p-6 rounded-xl border border-[#E8DCC8] flex items-start" data-id="element-87">
              <Check className="w-5 h-5 text-[#B85C38] mt-1 mr-3 flex-shrink-0" data-id="element-88" />
              <span className="text-[#4A3728] font-medium" data-id="element-89">{item}</span>
            </motion.div>)}
        </div>
      </Section>

      {/* For Whom Section */}
      <Section background="cream" data-id="element-90">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-91">
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-[#B85C38]" data-id="element-92">
            <h3 className="text-xl font-bold text-[#4A3728] mb-6 flex items-center" data-id="element-93">
              <span className="bg-[#B85C38] text-white w-8 h-8 rounded-full flex items-center justify-center mr-3 text-sm" data-id="element-94">
                ✓
              </span>
              Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-95">
              {['tienes 40+ y sientes que tu barriga cambió', 'te inflamas por la tarde/noche', 'estás cansada de dietas extremas', 'quieres resultados percibibles (comodidad/ropa) rápido'].map((item, i) => <li key={i} className="flex items-start text-[#4A3728]" data-id="element-96">
                  <span className="mr-2 text-[#B85C38]" data-id="element-97">•</span> {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-gray-300 opacity-80" data-id="element-98">
            <h3 className="text-xl font-bold text-[#6B5642] mb-6 flex items-center" data-id="element-99">
              <span className="bg-gray-300 text-white w-8 h-8 rounded-full flex items-center justify-center mr-3 text-sm" data-id="element-100">
                ✕
              </span>
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-101">
              {['buscas una promesa médica', 'quieres perder mucha grasa en 14 días', 'tienes síntomas severos y no estás dispuesta a consultar profesional'].map((item, i) => <li key={i} className="flex items-start text-[#6B5642]" data-id="element-102">
                  <span className="mr-2 text-gray-400" data-id="element-103">•</span> {item}
                </li>)}
            </ul>
          </div>
        </div>
      </Section>

      {/* Pricing / CTA Section */}
      <Section id="pricing" background="white" className="text-center" data-id="element-104">
        <div className="max-w-2xl mx-auto bg-[#F5F0E8] p-8 md:p-12 rounded-3xl border-2 border-[#E8DCC8] relative" data-id="element-105">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-[#B85C38] text-white px-6 py-2 rounded-full font-bold text-sm tracking-wide uppercase shadow-md" data-id="element-106">
            Oferta Especial
          </div>

          <p className="text-[#6B5642] mb-4 font-medium" data-id="element-107">
            Acceso inmediato por solo
          </p>
          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-108">
            <span className="text-3xl md:text-4xl text-[#8C7B6C] line-through font-serif" data-id="element-109">
              $17
            </span>
            <span className="text-6xl md:text-7xl font-bold text-[#B85C38] font-serif" data-id="element-110">
              $6.39
            </span>
          </div>
          <div className="inline-block bg-[#C9A962] text-[#4A3728] px-4 py-1 rounded-full text-sm font-bold mb-4" data-id="element-111">
            ¡Ahorra 62%!
          </div>
          <p className="text-[#6B5642] mb-8 text-sm" data-id="element-112">
            Lo puedes hacer con comida normal del súper.
          </p>

          <div className="mb-8" data-id="element-113">
            <p className="text-lg md:text-xl text-[#4A3728] italic font-serif mb-6" data-id="element-114">
              "Hazlo 14 días. No para 'ser perfecta'. <br data-id="element-115" />
              Para volver a sentir que tu cuerpo te responde."
            </p>
            <Button fullWidth className="text-lg md:text-xl py-5 shadow-xl hover:shadow-2xl" href="https://resetconcalma.com/cart/45233777672329:1" data-id="element-116">
              Quiero mi Plan Anti-Hinchazón
            </Button>
          </div>

          <div className="flex items-center justify-center space-x-4 text-xs text-[#8C7B6C]" data-id="element-117">
            <span className="flex items-center" data-id="element-118">
              <Check className="w-3 h-3 mr-1" data-id="element-119" /> Pago Seguro
            </span>
            <span className="flex items-center" data-id="element-120">
              <Check className="w-3 h-3 mr-1" data-id="element-121" /> Acceso Inmediato
            </span>
          </div>
        </div>
      </Section>

      {/* Footer */}
      <footer className="bg-[#4A3728] text-[#E8DCC8] py-12 text-center" data-id="element-122">
        <div className="max-w-4xl mx-auto px-4" data-id="element-123">
          <p className="font-serif text-2xl italic mb-6" data-id="element-124">
            Adiós 'Hormone Belly'
          </p>
          <p className="text-sm opacity-60" data-id="element-125">
            © {new Date().getFullYear()} Todos los derechos reservados. <br data-id="element-126" />
            Este producto no sustituye el consejo médico profesional.
          </p>
        </div>
      </footer>
    </div>;
}